'use strict';

/**
 * BD.GuestOptions: Code for managing the Guest Options cart step
 */
var BD = window.BD = window.BD || {};
BD.GuestOptions = (function($) {
  var $guestOptions;
  var $vipCheckboxes;
  var $vipCount;
  var $vipCountContainer;
  
  var guestCount;
  var maxVips;
  var hasCustomPickup;
  var submitCount = 0;

  function getGuestOptions() {
    var options;
    
    try {
      var guestFieldsStr = CartJS.getAttribute('guestFields');
      options =  guestFieldsStr ? JSON.parse(guestFieldsStr) : {};
    }
    catch (e) { options = {}; }
    
    options.guestNames = options.guestNames || [];
    options.guestVips = options.guestVips || [];
    options.guestMeals = options.guestMeals || [];
    options.guestLocations = options.guestLocations || [];

    return options;
  }
  
   function saveGuestOptions() {
    var newOptions = {
      guestNames: [],
      guestVips: [],
      guestLocations: [],
      guestMeals: []
    };
    
    $guestOptions.find('.guest-entry:not(#guestOption__rowTemplate)').each(function() {
      var $row = $(this);
      var idx = $row.data('guest-idx');
      newOptions.guestNames.push($row.find('.guestOption__name').val() || ('Guest ' + (idx + 1)));
      newOptions.guestVips.push(!!$row.find('.vip-checkbox').is(':checked'));
      newOptions.guestLocations.push($row.find('.guestOption__pickup').val() || '');
      newOptions.guestMeals.push($row.find('.guestOption__meal').val() || '');
    });

    var optionString = JSON.stringify(newOptions || '{}');
    CartJS.setAttribute('guestFields', optionString);
  }
  
  function submit(e) {
    if (countSelectedVips() < maxVips && submitCount++ < 1) {
      e.preventDefault();
      $vipCountContainer.addClass('error');

      $('html, body').animate({
        scrollTop: $vipCountContainer.closest('.row').offset().top - 100
      }, 500);
    }
  }
  
  function buildTable() {
    var options = getGuestOptions();
    var $rowTemplate = $('#guestOption__rowTemplate');
    var $entries = $rowTemplate.closest('.entries');
    var defaultPickupValue = (hasCustomPickup ? 'Custom' : $rowTemplate.find('.guestOption__pickup option').attr('value'));
    var defaultMeal = $rowTemplate.find('.guestOption__meal option').attr('value');

    for (var i = 0; i < guestCount; i++) {
      var $row = $rowTemplate.clone().removeAttr('id');
      var chkId = 'chk-vip-' + i;

      $row.find('#chk-vip-x').attr('id', chkId);
      $row.find('.crown label').attr('for', chkId);

      var name = options.guestNames[i] || '';
      var meal = options.guestMeals[i] || defaultMeal;
      var isVip = options.guestVips[i] || false;
      var pickup = options.guestLocations[i] || defaultPickupValue;

      $row.data('guest-idx', i);
      $row.find('.guestOption__name').attr('placeholder', 'Guest ' + (i + 1)).val(name);
      $row.find('.guestOption__meal').val(meal);
      $row.find('.guestOption__pickup').val(pickup);
      $row.find('.vip-checkbox').prop('checked', isVip);

      $entries.append($row);
    }

    $vipCheckboxes = $guestOptions.find('.vip-checkbox');
    updateCheckboxStatuses();
  }
  
  function updateVipStatus(e) {
    var $this = $(this);
    var $vipChk = $this.closest('.crown').find('.vip-checkbox');

    if (countSelectedVips() > maxVips) {
      $vipChk.prop('checked', false);
    }

    updateCheckboxStatuses();
    saveGuestOptions();
  }
  
  function updateCheckboxStatuses() {
    var vipCount = countSelectedVips();
    $vipCount.text(vipCount);

    $vipCheckboxes.each(function() {
      var $this = $(this);
      $(this).closest('.crown').toggleClass('selected', $this.is(':checked'));
    });

    $vipCountContainer.removeClass('error');
  }
  
  function countSelectedVips() {
    var selected = CartJS.getAttribute('charity');
    return $vipCheckboxes.filter(':checked').length;
  }
  
  function selectAllMeals() {
    var meal = this.value;
    if (!meal) { return; }

    $guestOptions.find('.guestOption__meal').val(meal);
    $(this).prop('selectedIndex', 0);
    saveGuestOptions();
  }
  
  function selectAllPickups() {
    var pickup = this.value;
    if (!pickup) { return; }
    
    $guestOptions.find('.guestOption__pickup').val(pickup);
    $(this).prop('selectedIndex', 0);
    saveGuestOptions();
  }
  
  function init() {
    $guestOptions = $('#guestOptions');
    if (!$guestOptions.length) { return; }

    $vipCount = $guestOptions.find('.guestVip__count');
    $vipCountContainer = $vipCount.closest('.guest_vip');
    
    $guestOptions.on('change', '.guestOption__name', saveGuestOptions);
    $guestOptions.on('change', '.guestOption__meal', saveGuestOptions);
    $guestOptions.on('change', '.guestOption__pickup', saveGuestOptions);
    $guestOptions.on('change', '.vip-checkbox', updateVipStatus);

    $guestOptions.find('#guestOptions__selectAllMeals').on('change', selectAllMeals);
    
    var $allPickupsSelector = $guestOptions.find('#guestOptions__selectAllPickups')
    $allPickupsSelector.on('change', selectAllPickups);
    
    hasCustomPickup = !!$allPickupsSelector.find('option[value=Custom]').length;
    
    guestCount = $guestOptions.data('guest-count');
    maxVips = $guestOptions.data('max-vips');

    $('.btn--nextStep').on('click', submit);
    buildTable();
    saveGuestOptions();
  }
  
  $(document).on('cart.ready', init);
})(jQuery);